import { render, staticRenderFns } from "./NumberCounterJs.vue?vue&type=template&id=268ae0fe&"
import script from "./NumberCounterJs.vue?vue&type=script&lang=js&"
export * from "./NumberCounterJs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports